// パンくず、メニュー用
import { TBreadcrumbItem } from "../../../../presentation/type/common";

namespace routeConfig {
  // customer
  export const customerRoot: TBreadcrumbItem = {
    text: ``,
    to: `/customer`,
    isHome: true,
  };

  export const customerExternalContractPlan: TBreadcrumbItem = {
    text: `プラン`,
  };

  export const customerExternalContracts: TBreadcrumbItem = {
    text: `契約管理`,
  };

  export const customerExternalContractCreate: TBreadcrumbItem = {
    text: `契約の編集`,
  };

  export const customerExternalContractEdit: TBreadcrumbItem = {
    text: `契約の新規作成`,
  };

  export const customerExternalContractActivities: TBreadcrumbItem = {
    text: `稼働ログ`,
  };

  // ?
  export const customerExternalContractActivityFile: TBreadcrumbItem = {
    text: `プレビュー`,
  };

  export const customerExternalContractInvoices: TBreadcrumbItem = {
    text: `請求書`,
  };

  export const customerExternalContractInvoiceCreate: TBreadcrumbItem = {
    text: `請求書 新規作成`,
  };

  export const customerExternalContractInvoiceEdit: TBreadcrumbItem = {
    text: `請求書 編集`,
  };

  export const customerExternalContractInvoiceInfo: TBreadcrumbItem = {
    text: `請求書 プレビュー`,
  };

  export const customerMessages: TBreadcrumbItem = {
    text: `メッセージ`,
  };

  export const customerProjects: TBreadcrumbItem = {
    text: `案件`,
  };

  export const customerMypage: TBreadcrumbItem = {
    text: `マイページ`,
  };

  export const customerPDF: TBreadcrumbItem = {
    text: `PDF`,
  };

  export const customerMypageEdit: TBreadcrumbItem = {
    text: `マイページ編集`,
  };

  export const customerMypageEmailUpdate: TBreadcrumbItem = {
    text: `メールアドレス変更`,
  };

  export const customerMypagePasswordUpdate: TBreadcrumbItem = {
    text: `パスワード変更`,
  };

  export const customerBlackList: TBreadcrumbItem = {
    text: `企業ブロック`,
  };

  export const customerEntries: TBreadcrumbItem = {
    text: `エントリー履歴`,
  };

  // client
  export const clientRoot: TBreadcrumbItem = {
    text: ``,
    to: `/client`,
    isHome: true,
  };

  // ?
  export const clientScout: TBreadcrumbItem = {
    text: `スカウト`,
  };

  export const clientMypage: TBreadcrumbItem = {
    text: `マイページ`,
  };

  export const clientMypageClientEdit: TBreadcrumbItem = {
    text: `マイページ編集`,
  };

  export const clientMypageCompanyInfo: TBreadcrumbItem = {
    text: `会社情報`,
  };

  export const clientMypageCompanyEdit: TBreadcrumbItem = {
    text: `会社情報編集`,
  };

  export const clientMypagePasswordUpdate: TBreadcrumbItem = {
    text: `パスワード変更`,
  };

  export const clientMypageEmailUpdate: TBreadcrumbItem = {
    text: `メールアドレス変更`,
  };

  export const clientProjects: TBreadcrumbItem = {
    text: `案件管理`,
  };

  export const clientProjectCreate: TBreadcrumbItem = {
    text: `案件登録`,
  };

  export const clientProjectEdit: TBreadcrumbItem = {
    text: `案件編集`,
  };

  //
  export const clientProjectPreview: TBreadcrumbItem = {
    text: `案件プレビュー`,
  };

  export const clientBilling: TBreadcrumbItem = {
    text: `料金プラン`,
  };

  export const clientBrowsingHistories: TBreadcrumbItem = {
    text: `閲覧履歴`,
  };

  export const clientBookmarks: TBreadcrumbItem = {
    text: `お気に入り`,
  };

  export const clientClientsInfoClients: TBreadcrumbItem = {
    text: `メンバー`,
  };

  export const clientClientsCreate: TBreadcrumbItem = {
    text: `メンバー新規追加`,
  };

  export const clientEntries: TBreadcrumbItem = {
    text: `エントリー一覧`,
  };

  export const clientMessages: TBreadcrumbItem = {
    text: `メッセージ`,
  };

  export const clientPmCampaign: TBreadcrumbItem = {
    text: "PMキャンペーン",
  };

  export const clientSalesCampaign: TBreadcrumbItem = {
    text: "営業特集",
  };

  export const clientIpoCampaign: TBreadcrumbItem = {
    text: "IPO・IR特集",
  };
}

export { routeConfig };



// WEBPACK FOOTER //
// ./src/config/language/ja-JP/presentation/route_text.ts